import api from '../../../../libs/api';
import { useMutation } from 'react-query';
import DownloadContentUtiles from '../../../../libs/download-content.utils';
const useRelaticsDownloadXml = () =>{
    const previewFileFn = (parameters: any) => {
        return api.get(parameters.endpoint, {
            params: { relaticsSyncImportLogId: parameters.id, type: parameters.type },
            safe: true,
            contentType: 'text/plain',
        });
    };

    const downloadFileXmlMutation = useMutation(previewFileFn);

    const handleDownloadDocument = (item: any, type: number) => {
        var params = {
            endpoint: '/api/v2/AsiteRelaticsSync/DownloadXmlFileByRelaticsSyncLogIdAndType',
            id: item.id ?? 0,
            type,
        };

        downloadFileXmlMutation.mutate(params, {
            onSuccess: (result: any) => {
                DownloadContentUtiles.download(
                    result,
                    type ? item.fileNameDocumentResponse : item.fileNameDocumentSend,
                    'text/xml',
                );
            },
        });
    };
    return {handleDownloadDocument, downloadFileXmlMutation};
}
export default useRelaticsDownloadXml;